import { render, staticRenderFns } from "./BRA.vue?vue&type=template&id=b49ab62c&scoped=true&"
import script from "./BRA.vue?vue&type=script&lang=js&"
export * from "./BRA.vue?vue&type=script&lang=js&"
import style0 from "./BRA.vue?vue&type=style&index=0&id=b49ab62c&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b49ab62c",
  null
  
)

export default component.exports